/**
 * goToApp(path) — hard redirect into the app host.
 *
 * The public join/assignment pages are served on the apex domain
 * (teachtappy.ai), whose router catch-all sends unknown paths to the
 * landing page. Worse, after /api/classroom/join the auth cookie exists
 * but the running React app still has logged-out state, so even a soft
 * navigate() on the app host renders the anonymous branch.
 *
 * A full page load fixes both: cookies are domain-scoped (.teachtappy.ai)
 * so the session carries across the hop, and the app boots freshly as the
 * newly minted student.
 */
export const goToApp = (path) => {
  const host = window.location.hostname.replace(/^www\./, '');
  if (host === 'localhost' || host === '127.0.0.1' || host.startsWith('app.')) {
    window.location.href = path;
  } else {
    window.location.href = `https://app.${host}${path}`;
  }
};

export default goToApp;
